import React from 'react'
import { CustomerSay, WhoCarousel, ChoosingProduct, FeelTrust, Layout, Carousel } from '../components'

const HomePage = () => {
  return (
    <Layout showCommonFooter={true}>
      <main>
        <Carousel />
        <ChoosingProduct />
        <WhoCarousel />
        <CustomerSay />
        <FeelTrust />
      </main>
    </Layout>
  )
}

export default HomePage
